import React from "react";
import { BladeCommonSchema } from "../../../types";
import { LinkItemSchema } from "../../../schemas/LinkItem";
import { z } from "zod";
import { RichTextSchema } from "../../../schemas/RichText";
import styled from "styled-components";
import { RichText } from "../../../components/RichText";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { riotProductSkin } from "../skins/riot-product/rsoModal";
import { SkinId } from "../../../skins/types";
import { CTA } from "../../../components/CTA";
import { Icon } from "../../../components/Icon";
import { LightboxClose } from "../../../components/Lightbox";
import { RSOPrompt, createAuthorizationUrl, setRedirectUri } from "./utils";
import { WebActionType } from "../../../schemas/Actions";
import { useActionReducer } from "../../../context/ActionProvider";
import { lolProductSkin } from "../skins/lol-product/rsoModal";
import { useRegistrationEvents } from "@riotgames/gtm-tracker-rg-web";
import { SessionStorageProvider } from "@riotgames/browserstorage-rg-web";
export const RsoModalSchema = BladeCommonSchema.extend({
    rsoModalTitle: z.string().optional(),
    description: z.string().optional(),
    signupPrompt: z.string(),
    signupLink: LinkItemSchema,
    loginPrompt: z.string(),
    loginLink: LinkItemSchema,
    subtext: RichTextSchema.optional(),
});
export const RsoModalExtendedSchema = RsoModalSchema.extend({
    locale: z.string(),
});
const _RsoModal = ({ className, rsoModalTitle, description, signupPrompt, signupLink, loginPrompt, loginLink, subtext, protectedUrl, locale, }) => {
    const { dispatchAction } = useActionReducer();
    const { trackRegistrationStart } = useRegistrationEvents({});
    async function handleRegistrationButtonClick(prompt, linkItem) {
        trackRegistrationStart(prompt);
        if (linkItem.action?.type === WebActionType.Weblink && linkItem.action.requiresAuthentication) {
            const redirectUri = protectedUrl || setRedirectUri(prompt, linkItem.action.payload.url);
            const { authorizationUrl } = await createAuthorizationUrl(prompt, locale, redirectUri);
            window.location.assign(authorizationUrl);
        }
        else {
            dispatchAction(linkItem.action);
        }
    }
    return (React.createElement("div", { className: className, "data-testid": "RiotBar-RsoModal", onClick: (e) => e.stopPropagation() },
        React.createElement(LightboxClose, null,
            React.createElement(Icon, { className: "close-icon", name: "close" })),
        React.createElement("div", { className: "main-content" },
            React.createElement("div", { className: "header" },
                rsoModalTitle && React.createElement("h3", null, rsoModalTitle),
                description && React.createElement("p", { className: "description" }, description)),
            React.createElement("div", { className: "buttons" },
                React.createElement("div", { className: "button-container" },
                    signupPrompt && React.createElement("p", null, signupPrompt),
                    signupLink?.action && (React.createElement(CTA, { variant: "secondary", onClick: () => handleRegistrationButtonClick(RSOPrompt.SIGNUP, signupLink) }, signupLink?.title))),
                React.createElement("div", { className: "button-container" },
                    React.createElement("p", null, loginPrompt),
                    React.createElement(CTA, { variant: "primary", onClick: () => handleRegistrationButtonClick(RSOPrompt.LOGIN, loginLink) }, loginLink?.title)))),
        subtext && React.createElement(RichText, { className: "subtext", ...subtext })));
};
const WrappedRsoModal = (props) => (React.createElement(SessionStorageProvider, null,
    React.createElement(_RsoModal, { ...props })));
export const RsoModal = styled(WrappedRsoModal) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.LoL]: lolProductSkin,
})}
`;
//# sourceMappingURL=RsoModal.js.map